/**
 * Cleaner - history & cache clean — one-click browsing-data cleaner
 *
 * Declares a single web-accessible-resource entry whose resource list is the bare glob
 * "*", matched to every origin with no dynamic URL — so every bundled file, including the
 * icons and content scripts, is fetchable from any page at a fixed URL. The 128px icon is
 * the cleanest signal: an image loads through probeImage with no CORS grant.
 *
 * Manifest verified against version 1.1.33.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pooaemmkohlphkekccfajnbcokjlbehk';

export const cleaner: ExtensionDefinition = {
  id: ID,
  name: 'Cleaner - history & cache clean',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Exposes every bundled file (WAR glob "*") to every origin with no dynamic URL. The ' +
    '128px icon loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load img/icon_128.png via <img> — the extension icon, exposed to every origin ' +
        'and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'img/icon_128.png'),
    },
    {
      id: 'war-content-js',
      kind: 'web-accessible-resource',
      description: 'Fetch js/content.js — the content script, a second independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/content.js'),
    },
    {
      id: 'war-content-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/content.css — the content-script stylesheet, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/content.css'),
    },
  ],
};
